import { useState, useEffect } from 'react'

// useState que persiste em localStorage. Namespaced com 'atd:' para não
// colidir com outras views. Tolerante a falhas (modo privado, storage cheio).
const PREFIX = 'atd:'

const read = (key, fallback) => {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    return raw == null ? fallback : JSON.parse(raw)
  } catch {
    return fallback
  }
}

export function usePersistentState(key, fallback) {
  const [value, setValue] = useState(() => read(key, fallback))

  useEffect(() => {
    try { localStorage.setItem(PREFIX + key, JSON.stringify(value)) } catch { /* ignore */ }
  }, [key, value])

  return [value, setValue]
}
